<div class="individual-header-map">
  <google-map
    class="individual-header-map__map"
    [class.individual-header__map--with-image]="imageUrl$ | async"
    [width]="null"
    height="100%"
    [center]="center$ | async"
    [options]="mapOptions"
  >
    <map-marker #marker [position]="center$ | async" [options]="markerOptions$ | async"></map-marker>
  </google-map>
  <div class="individual-header-map__image-container" *ngIf="imageUrl$ | async; let url">
    <img class="individual-header-map__image" [src]="url" />
  </div>
</div>
